// @flow
import * as React from 'react';
import Modal from 'react-modal';
import Group from 'entities/Group';
import CurrentUser from 'auth/CurrentUser';
import { withRouter } from 'app/context/Router';
import GroupSettingsModal from 'groups/components/GroupSettingsModal';

type Props = {
  router: *,
  group: Group,
};

class GroupSettingsHandler extends React.Component<Props, {}> {
  handleHide = () => {
    this.props.router.replace(`/classes/${this.props.group.getCode() || ''}`);
  };

  render() {
    return (
      <Modal isOpen>
        <GroupSettingsModal
          group={this.props.group}
          onRequestHide={this.handleHide}
          userIsTeacher={CurrentUser.getUser().isTeacher()}
          onCodeChange={code => this.props.router.push(`/classes/${code}`)}
        />
      </Modal>
    );
  }
}

export { GroupSettingsHandler };
export default withRouter(GroupSettingsHandler);
